import { post,get } from './index'
export default {
  getPolicyStudyByCondition: (params) => post('PolicyStudy/getPolicyStudyByCondition', params),
  getDetails: (id) => get('PolicyStudy/getDetails/' + id),
};
